import { ExerciseSelection } from '../../entities';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { CardioOrResistance, Exercise, Level } from './../../entities/exercise/exercise';
import { IExerciseSelectionFilter } from './workoutselectionmanager';

export class ResistanceCardioFilter implements IExerciseSelectionFilter {
    public description: string = 'Return only cardio, resistance or balance exercises based on setting';
    public name: string = 'ResistanceCardioFilter';
    public filter(inputExercises: Exercise[],
                  exerciseSelection: ExerciseSelection,
                  userWorkoutSettings: WorkoutSettings,
                  selectedZoneExercisesSoFar: Exercise[]): Exercise[] {
        const level = userWorkoutSettings.level;
        const cardioOrResistanceSetting = userWorkoutSettings.cardioOrResistance;

        // Beginner workouts required the use of Build exercises in Burn workouts (except for Balance)
        if (level === Level.Beginner && cardioOrResistanceSetting !== CardioOrResistance.Balance) {
            return inputExercises.filter((e) => e.cardioOrResistance != null &&
                e.cardioOrResistance.indexOf(CardioOrResistance.Balance) === -1);
        }
        return inputExercises.filter((e) => e.cardioOrResistance != null &&
                                            e.cardioOrResistance.indexOf(cardioOrResistanceSetting) > -1 );
    }
}
